import { Notification as NotificationType } from "@/redux/services/notification/notification.type";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NotificationState {
  notifications: NotificationType[];
}

const initialState: NotificationState = {
  notifications: [],
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<NotificationType>) => {
      // The same notification can arrive twice (Mercure and the polling
      // fallback): keep one row per id (SFRESTO-141).
      const id = action.payload.id;
      if (id && state.notifications.some((n) => n.id === id)) return;
      state.notifications.unshift(action.payload);
    },

    changeReadStatus: (
      state,
      action: PayloadAction<{ id: string; isRead: boolean }>
    ) => {
      const index = state.notifications.findIndex(
        (n) => n.id === action.payload.id
      );
      if (index !== -1) {
        state.notifications[index].isRead = action.payload.isRead;
      }
    },

    setNotifications: (state, action: PayloadAction<NotificationType[]>) => {
      state.notifications = action.payload;
    },
  },
});

export const { addNotification, changeReadStatus, setNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
